import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import ReactPlayer from "react-player";
import { Backward15, Forward15, PauseButton, PlayButton } from "../../Assets/svg";
import SeekBar from "../SeekBar";
import { setClearAndStopMixerTrayTrack } from "../../Store/Slices/MyMixerSlice";
import { activeUser } from "../../Store/Slices/APIs";
import { removeAllTracks } from "../../Store/Slices/PlayerSlice";

const IndividualAudioPlayer = ({ url }) => {

    const dispatch = useDispatch();

    const playerRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);

    // Seek forward/backward
    const handleSeek = (time) => {
        const safeTime = Math.max(0, Math.min(time, duration)); // avoid overflow
        playerRef.current.seekTo(safeTime, "seconds");
        setCurrentTime(safeTime);
    };

    const handleEnded = () => {
        setPlaying(false);   // stop playback
        setCurrentTime(0);   // reset seek
        playerRef.current.seekTo(0, "seconds"); // reset seekbar
    };

    const handlePlayPause = () => {
        setPlaying(!playing)
        dispatch(setClearAndStopMixerTrayTrack(true));
        dispatch(activeUser());
        dispatch(removeAllTracks())
    }

    return (
        <div className="text-center px-3">
            {/* Hidden audio element */}
            <ReactPlayer
                ref={playerRef}
                url={url}
                playing={playing}
                height="0px"
                width="0px"
                onDuration={(d) => setDuration(d)}
                onProgress={({ playedSeconds }) => setCurrentTime(playedSeconds)}
                onEnded={handleEnded}   // reset on completion
            />

            {/* Forward / Backward */}
            <div className="d-flex align-items-center justify-content-between">
                <button className="btn border-0 p-0 position-relative" style={{ right: '3px' }} onClick={() => handleSeek(currentTime - 15)}><img src={Backward15} width={45} /></button>
                <button className="btn border-0 p-0 position-relative" style={{ right: "-14px" }} onClick={() => handleSeek(currentTime + 15)}><img src={Forward15} width={45} /></button>
            </div>

            {/* Reusable Seek Bar */}
            <SeekBar
                currentTime={currentTime}
                duration={duration}
                onSeek={(time) => handleSeek(time)}
            />

            {/* Play / Pause */}
            <div className="ppButton mt-3 mt-sm-0 pt-sm-2">
                <button
                    type="button"
                    className="no-button"
                    onClick={handlePlayPause}
                >
                    {playing ? <img src={PauseButton} /> : <img src={PlayButton} />}
                </button>
            </div>
        </div >
    );
};

export default IndividualAudioPlayer;
